//
//
//
//
//
//

import { parentMixin } from '../../mixins/multi-items'

export default {
  mixins: [parentMixin],
  props: {
    iconClass: String
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/tabbar/tabbar.vue